import cn from 'classnames';
import { FC, ReactNode } from 'react';
import { Link } from 'react-router';

import styles from './text-link.module.scss';

type TextLinkProps = {
  to: string;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
};

export const TextLink: FC<TextLinkProps> = (props) => {
  const { to, children, className, disabled } = props;

  if (disabled) {
    return (
      <span
        className={cn(styles.textLink, styles.disabled, className)}
        aria-disabled
      >
        {children}
      </span>
    );
  }

  return (
    <Link className={cn(styles.textLink, className)} to={to}>
      {children}
    </Link>
  );
};
